import { render, staticRenderFns } from "./BSignUpContinueFromApp.vue?vue&type=template&id=2c015705&"
import script from "./BSignUpContinueFromApp.vue?vue&type=script&lang=ts&"
export * from "./BSignUpContinueFromApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports